export const LOCALE_CODES = [
  'en-AU',
  'en-HK',
  'zh-HK',
  'en-ID',
  'id-ID',
  'ko-KR',
  'en-MY',
  'en-NZ',
  'en-PH',
  'en-SG',
  'en-TH',
  'th-TH',
] as const

export const CURRENCY_SYMBOLS = {
  AU: '$',
  HK: '$',
  ID: 'Rp',
  KR: '원',
  MY: 'RM',
  NZ: '$',
  PH: '₱',
  SG: '$',
  TH: '฿',
} as const

export type LocaleCodes = (typeof LOCALE_CODES)[number]

export const SUFFIXED_CURRENCY_LOCALES = ['ko-KR']

export const FONT_SIZE_CHART = {
  s: {
    sizingLength: 8,
    token: 'var(--size-typescale-body-s-size)',
  },
}
